var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55202 5.99998C5.40601 6.00074 5.26126 5.97554 5.12608 5.9258C4.9909 5.87607 4.86795 5.8028 4.76428 5.71018L0.326294 1.71292C0.222846 1.61974 0.140787 1.50913 0.0848013 1.38739C0.0288157 1.26565 2.18e-09 1.13517 0 1.0034C-2.18e-09 0.871635 0.0288157 0.741156 0.0848013 0.619417C0.140787 0.497679 0.222846 0.387065 0.326294 0.29389C0.429742 0.200715 0.552552 0.126805 0.687713 0.076379C0.822874 0.0259532 0.967739 -1.96351e-09 1.11404 0C1.26033 1.96351e-09 1.4052 0.0259532 1.54036 0.076379C1.67552 0.126805 1.79833 0.200715 1.90178 0.29389L5.55202 3.60163L9.21336 0.423801C9.31543 0.321581 9.43981 0.239429 9.57873 0.182482C9.71766 0.125535 9.86813 0.0950183 10.0207 0.0928405C10.1734 0.0906628 10.3248 0.11687 10.4657 0.169825C10.6065 0.222779 10.7338 0.301342 10.8394 0.400599C10.945 0.499855 11.0267 0.61767 11.0795 0.746676C11.1322 0.875682 11.1548 1.0131 11.1459 1.15035C11.137 1.28759 11.0968 1.4217 11.0277 1.54429C10.9586 1.66688 10.8622 1.77532 10.7445 1.86282L6.30648 5.72018C6.10358 5.89637 5.83384 5.99641 5.55202 5.99998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownWhite);
export default __webpack_public_path__ + "static/media/chevron-down-white.a7dc84d4dd414df0b5c0edf7d180e5f6.svg";
export { ForwardRef as ReactComponent };